import React, { Component } from 'react';
import Select from 'react-select';
import services from './data';

let CategoryOptions = [];

class SubscriptionPackageFeatures extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
    };
  }

  componentDidMount() {
    services
      .getSubscriptionPackages()
      .then((response) => {
        const tmp = response.data.data;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: tmp[i].module,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];
    this.props.handlePackageChange(selectedValues);
  };

  render() {
    const { options } = this.state;
    const selectedOptions = options.filter((option) =>
      this.props.value.includes(option.value),
    );

    return (
      <Select
        isMulti
        onChange={this.handleChange}
        options={options}
        className="select-box-container"
        classNamePrefix="raw-select"
        name="package"
        placeholder="Select Package Features"
        value={selectedOptions}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { SubscriptionPackageFeatures };
